import { FC, useState, useCallback, useMemo } from 'react'
import { includes, filter } from 'lodash'
import Cookies from 'js-cookie'
import Announcement from './Announcement'

type AnnouncementItem = {
  id: string | number
  message: string
}

type AnnouncementsProps = {
  options: {
    announcements: AnnouncementItem[]
  }
}

const Announcements: FC<AnnouncementsProps> = ({ options }) => {
  const COOKIE_NAME = 'dismissedAnnouncements'

  const getDismissedIds = useCallback((): string[] => {
    const cookieString = Cookies.get(COOKIE_NAME)
    return cookieString ? cookieString.split(',') : []
  }, [])

  const [dismissedIds, setDismissedIds] = useState<string[]>(getDismissedIds)

  const isIdStored = useCallback(
    (id: string | number | null): boolean => {
      if (id != null) {
        return includes(dismissedIds, id.toString())
      }
      return false
    },
    [dismissedIds]
  )

  const storeId = useCallback(
    (id: string | number | null) => {
      if (id != null && !isIdStored(id)) {
        const updatedDismissedIds = [...dismissedIds, id.toString()]
        Cookies.set(COOKIE_NAME, updatedDismissedIds.join(','))
        setDismissedIds(updatedDismissedIds)
      }
    },
    [dismissedIds, isIdStored]
  )

  const handleDismiss = useCallback(
    (id: string | number | null) => {
      storeId(id)
    },
    [storeId]
  )

  const undismissedAnnouncements = useMemo(() => {
    return filter(options.announcements, item => !isIdStored(item.id))
  }, [options.announcements, isIdStored])

  if (undismissedAnnouncements.length > 0) {
    return (
      <div>
        {undismissedAnnouncements.map(item => (
          <Announcement key={`announcement_${item.id}`} message={item.message} id={item.id} onDismiss={handleDismiss} />
        ))}
      </div>
    )
  }
  return null
}

export default Announcements
